import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import BrandStrip from "../components/BrandStrip";
import OurStory from "../components/OurStory";
import PersonalityGrid from "../components/PersonalityGrid";
import FeaturedRail from "../components/FeaturedRail";
import CollectionGrid from "../components/CollectionGrid";
import WhySol from "../components/WhySol";
import Reviews from "../components/Reviews";
import FAQ from "../components/FAQ";
import CtaBanner from "../components/CtaBanner";
import QuizTeaser from "../components/QuizTeaser";
import InAction from "../components/InAction";

/**
 * Section flow (tightened):
 *   Hero → Our Story → Collection (8 + view all) → By Personality → Find Their Pair
 *   → CTA → In Action (single strip) → Reviews → Why SOL → FAQ → Footer
 */
export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TrustBar />

      {/* 1. Our Story */}
      <OurStory />
      <BrandStrip />

      {/* 2. Collection */}
      <FeaturedRail />
      <CollectionGrid
        title="Shop by collection"
        subtitle="Every frame, named with care. Pick the one that feels like them."
        limit={8}
      />

      {/* 3. By Personality */}
      <PersonalityGrid />

      {/* 4. Find Their Pair */}
      <QuizTeaser />

      {/* Supporting lifestyle layer */}
      <CtaBanner />
      <InAction />
      <Reviews />

      {/* 5. Why SOL */}
      <WhySol />

      {/* 6. FAQ */}
      <FAQ />
    </div>
  );
}
